// Expenses Reducer

const expensesReducerDefaultState = [];

export default (state = expensesReducerDefaultState, action) => {
  switch (action.type) {
    case 'SET_EXPENSES':
      return action.expenses

    case 'IMPORT_EXPENSE':
      console.log("Action: IMPORT_EXPENSE ", action.metadata)
      return action.metadata

    case 'ADD_EXPENSE':
      return [
        ...state,
        action.expense
      ];
    case 'REMOVE_EXPENSE':
      return state.filter(({ id }) => id !== action.id);
    case 'EDIT_EXPENSE':
      return state.map((expense) => {
        if (expense.id === action.id) {
          return {
            ...expense,
            ...action.updates
          };
        } else {
          return expense;
        };
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/expenses.js